module.exports = __webpack_public_path__ + "static/media/gif.23159392.gif";